// extracted by mini-css-extract-plugin
export default {"errorMessage":"LoginError_errorMessage__HFZYb","hidden":"LoginError_hidden__7gjJr"};